import { getCommercialSegments } from "@/lib/api/commercialSegment"
import { CommercialSegment } from "@/lib/types/commercialSegment"
import { defineStore } from "pinia"

interface CommercialSegmentState {
    commercialSegments: CommercialSegment[]
    loading: boolean
}

export const useCommercialSegmentsStore = defineStore('commercialSegments', {
    state: (): CommercialSegmentState => ({
        commercialSegments: [],
        loading: false
    }),
    actions: {
        async fetchAll(): Promise<void> {
            this.loading = true

            try {
                const res = await getCommercialSegments()
                this.commercialSegments = res
            } catch (err) {
                console.error(err)
            } finally {
                this.loading = false
            }
        },
    },
    getters: {
        getByIds: (state) => {
            return (ids: string[]): CommercialSegment[] => {
                return state.commercialSegments.filter(cs => ids.includes(cs.id))
            }
        }
    }
})